<xng-breadcrumb></xng-breadcrumb>

<div class="container pt-4">
  <div class="d-flex justify-content-end mb-3">
    <a [routerLink]="['new-worker']" class="custom_button" translate><i class='bx orange bx-plus mr-1'></i>workers.newWorker</a>
  </div>

  <div class="row">
    <app-search-input class="col-4" [placeholder]="'global.searchByName' | translate" [searchControl]="searchControlName"></app-search-input>
    <app-search-input class="col-4" [placeholder]="'global.searchByEmail' | translate" [searchControl]="searchControlEmail"></app-search-input>
  </div>
  
  <div *ngIf="users && !users.length" translate>workers.noWorkers</div>
  
  <ng-container *ngIf="users && users.length">
    <div app-users-list [users]="users" [userType]="'worker'" (onDelete)="onDeleteUser($event)" (onSeeInventars)="seeInventars($event)"></div>
  </ng-container>
</div>

<app-modal (close)="toggleDeleteUser = !toggleDeleteUser" *ngIf="toggleDeleteUser">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate
        [translateParams]="{name: selectedUser.name}">global.deleteInfo</h4>
    </div>
    <div class="modal-body">
      <button class="custom_button" (click)="deleteUser()" translate>global.yes</button>
      <button class="custom_button" (click)="toggleDeleteUser = false;" translate>global.no</button>
    </div>
  </div>
</app-modal>

<app-modal (close)="onCloseInventars()" *ngIf="toggleInventars">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: initial; font-size: 1rem; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>filials.filial.assignedInventars</h4>
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-between mb-2 align-items-center">
        <select class="form-control mx-1" name="filial" (change)="loadInventars()" [(ngModel)]="selectedFilialId">
          <option value="" disabled>Select Filial</option>
          <option *ngFor="let filial of filials" [value]="filial.id">{{filial.name}}</option>
        </select>
        <select class="form-control" name="inventar" [(ngModel)]="selectedInventarId">
          <option value="" disabled>Select Inventar</option>
          <option *ngFor="let inventar of inventars" [value]="inventar.id">{{inventar.name}}</option>
        </select>
        <button class="custom_button" (click)="assignWorkerToInventar()" translate>global.assign</button>
      </div>
      <div *ngIf="!selectedUser.inventars.length" translate>filials.filial.noAssignedInventories</div>
      <div *ngIf="selectedUser.inventars.length" translate>filials.filial.assignedInventars</div>
      <div *ngFor="let inventar of selectedUser.inventars">
        <div class="d-flex justify-content-between mb-2 align-items-center list_container">
          <span>{{inventar.name}}</span>
          <button class="custom_button" (click)="unassignWorker(inventar)">X</button>
        </div>
      </div>
    </div>
  </div>
</app-modal>